<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=windowHash>
</sub-header>
<p-scrollPanel styleClass="custombar1" [style]="{width: '100%', height: '80vh'}">
  <div cdkTrapFocus [cdkTrapFocusAutoCapture]="true" class="container-fluid">
    <!-- ARBOL DE DATOS -->
    <div class="row">
      <div class="col-12  m-t-md m-b-sm">
        <label for="filterText" class="col-12 p-0">{{ 'General.search.maxLength' | translate:{maxLength:
          this.MIN_SEARCH_TEXT_LENGHT} }} <span *ngIf="this.isLoading()" class="m-xs" class="leyenda">
            <i class="fa fa-spinner loading-spin" aria-hidden="true"></i> {{ 'Filtrando'}} </span></label>
        <div class="col-12 p-0 btn-group">
          <input id="filterText" autofocus appDebounceUpKey class="form-control  form-control-sm" type="text"
            placeholder="{{ 'SearchGeneric.enter.text' | translate }}" name="filterText" id="filterTextInput"
            [(ngModel)]="filterText" (debounceUpKey)="updateFilter()" autocomplete="off" />
        </div>
        <div class="col-12  m-t-md m-b-sm p-0">
          <div *ngIf="filteredDivisions!==undefined&&filteredDivisions.length>0; else noDataTemplate">
            <p-tree [value]="filteredDivisions" selectionMode="single" (onNodeSelect)="accept($event)">
              <ng-template let-node pTemplate="default">
                <span><i aria-hidden="true" class="{{getIconClass(node.data.documentClass.identifier)}} fa-lg mr-1"></i>
                  <span [innerHTML]="node.label"></span></span>
              </ng-template>
            </p-tree>
          </div>
          <ng-template #noDataTemplate>
            <div class="alert alert-info text-center m-t-md">
              <span>
                <i class="fa fa-info-circle fa-1-5x float-left" aria-hidden="true"></i> {{ 'SearchGeneric.noDataFound' |
                translate }}</span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</p-scrollPanel>